import Image1284 from "../thumbnails/1284-MobileFaq.png";
import Image642 from "../thumbnails/642-MobileFaq.png";
import Image321 from "../thumbnails/321-MobileFaq.png";
import Image160 from "../thumbnails/160-MobileFaq.png";
import Image80 from "../thumbnails/80-MobileFaq.png";
export default {1284: Image1284, 642: Image642, 321: Image321, 160: Image160, 80: Image80, }